// import { useContext } from "react";

import { Box, Text } from "@chakra-ui/react";

import { Block } from "./MainBlocks/Block";

// import { Breakpoints } from "../../../context";

import CustomScroll from "react-custom-scroll";

export const Head01 = ({
  id,
  side,
  sentence,
  fam,
  size,
  height,
  spacing,
  weight,
  settings,
}) => {
  // console.log(
  //   sentence.length > 25
  //     ? sentence.split("").slice(0, 25).join("") + "..."
  //     : sentence
  // );

  // const device = useContext(Breakpoints);

  return (
    <Block id={id} sidebar={side}>
      <Box mb="8px">
        <CustomScroll>
          <Text
            width={{ base: "2000px", md: "100%", lg: "100%" }}
            maxHeight="500px"
            minH="100%"
            style={{ transition: "all .3s ease" }}
            fontFamily={fam}
            fontSize={size}
            lineHeight={`${height}px`}
            letterSpacing={`${spacing}px`}
            fontWeight={weight}
            mb="8px"
            // mb="16px"
            // mb="30px"
          >
            {/* {device === "tab"
              ? sentence.length > 49
                ? sentence.split("").slice(0, 49).join("") + "..."
                : sentence
              : sentence} */}
            {sentence}
            {/* {sentence.length > 49 ? sentence + "..." : sentence} */}
            {/* {sentence.length > 49
          ? sentence.split("").slice(0, 49).join("") + "..."
          : sentence} */}
          </Text>
        </CustomScroll>
      </Box>
      <hr style={{ width: "85%" }} />

      {/* Settings Block */}
      {settings}
    </Block>
  );
};
